import React from "react";
import EditorEditIcon from "@atlaskit/icon/glyph/editor/edit";
import styled from "@emotion/styled";

import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { Button } from "../../UI/Button";
import { COLOR_MISCHKA } from "../../constants/styles";

interface IProps {
  isLoading?: boolean;
  handleEdit: VoidFunction;
  isDisabled?: boolean;
}

const StyledButton = styled(Button)`
  min-width: 32px;
  min-height: 32px;
  border: 1px solid ${COLOR_MISCHKA} !important;
  padding: 0;
`;

export const EditButton: React.FC<IProps> = (props) => (
  <ReadOnlyWrapper>
    <StyledButton
      isDisabled={props.isDisabled}
      isLoading={props.isLoading}
      appearance="subtle"
      onClick={props.handleEdit}
      iconAfter={<EditorEditIcon label="edit" />}
    />
  </ReadOnlyWrapper>
);

EditButton.defaultProps = {
  isLoading: false,
};
